// extracted by mini-css-extract-plugin
export default {"small":"VerticalSpace_small__sS9Lo","normal":"VerticalSpace_normal__MArkt","large":"VerticalSpace_large__06iA-"};